import {makeGet} from '@yandex-delivery/utils'

import type {SuggestObject, SuggestResponse} from '../types'

export const phoenixSuggestGetter = makeGet<SuggestResponse>()
export const suggestObjectGetter = makeGet<SuggestObject>()
